export default function download(url: string, filename = 'download') {
  const anchor = document.createElement('a');
  anchor.download = filename;
  anchor.href = url;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}

export function downloadPromise(url: string, filename: string): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    try {
      download(url, filename);
      return resolve();
    } catch (error) {
      return reject(error);
    }
  });
}
